"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInformation = void 0;
const react_1 = __importStar(require("react"));
const UserInformationContainer_1 = require("decentraland-ui/dist/components/UserInformationContainer/UserInformationContainer");
const types_1 = require("decentraland-ui/dist/components/Notifications/types");
const utils_1 = require("../../modules/analytics/utils");
const utils_2 = require("../../modules/translation/utils");
const constants_1 = require("./constants");
const notifications_1 = require("../../modules/notifications");
const NOTIFICATIONS_QUERY_INTERVAL = 60000;
const UserInformation = (props) => {
    const analytics = (0, utils_1.getAnalytics)();
    const { hasTranslations, onSignOut, onSignIn, onOpen, onClickBalance, withNotifications, identity } = props, rest = __rest(props, ["hasTranslations", "onSignOut", "onSignIn", "onOpen", "onClickBalance", "withNotifications", "identity"]);
    const [{ isLoading, notifications }, setUserNotifications] = (0, react_1.useState)({
        isLoading: false,
        notifications: []
    });
    const [notificationsState, setNotificationsState] = (0, react_1.useState)({
        activeTab: types_1.NotificationActiveTab.NEWEST,
        isOnboarding: (0, notifications_1.checkIsOnboarding)(),
        isOpen: false
    });
    let client;
    if (identity) {
        client = new notifications_1.NotificationsAPI({ identity });
    }
    const translations = (0, react_1.useMemo)(() => {
        if (!props.hasTranslations) {
            return undefined;
        }
        return {
            signIn: (0, utils_2.t)('@dapps.user_menu.sign_in'),
            signOut: (0, utils_2.t)('@dapps.user_menu.sign_out'),
            guest: (0, utils_2.t)('@dapps.user_menu.guest'),
            settings: (0, utils_2.t)('@dapps.user_menu.settings'),
            wallet: (0, utils_2.t)('@dapps.user_menu.wallet'),
            profile: (0, utils_2.t)('@dapps.user_menu.profile'),
            myAssets: (0, utils_2.t)('@dapps.user_menu.my_assets'),
            myLists: (0, utils_2.t)('@dapps.user_menu.my_lists')
        };
    }, [hasTranslations]);
    const trackMenuItemClick = (0, react_1.useCallback)((type, track_uuid) => {
        if (analytics) {
            analytics.track(constants_1.DROPDOWN_MENU_ITEM_CLICK_EVENT, {
                type,
                track_uuid
            });
        }
    }, [analytics]);
    const handleOpen = (0, react_1.useCallback)((track_uuid) => {
        if (analytics) {
            analytics.track(constants_1.DROPDOWN_MENU_DISPLAY_EVENT, { track_uuid });
        }
        if (onOpen) {
            onOpen(track_uuid);
        }
    }, [analytics, onOpen]);
    const handleClickBalance = (0, react_1.useCallback)(network => {
        if (analytics) {
            analytics.track(constants_1.DROPDOWN_MENU_BALANCE_CLICK_EVENT, { network });
        }
        if (onClickBalance) {
            setTimeout(() => {
                onClickBalance(network);
            }, 300);
        }
    }, [analytics, onClickBalance]);
    const handleSignOut = (0, react_1.useCallback)((track_uuid) => {
        if (analytics) {
            analytics.track(constants_1.DROPDOWN_MENU_SIGN_OUT_EVENT, { track_uuid });
        }
        if (onSignOut) {
            setTimeout(() => {
                onSignOut(track_uuid);
            }, 300);
        }
    }, [analytics, onSignOut]);
    const handleSignIn = (0, react_1.useCallback)(() => {
        if (analytics) {
            analytics.track(constants_1.DROPDOWN_MENU_SIGN_IN_EVENT);
        }
        if (onSignIn) {
            setTimeout(() => {
                onSignIn();
            }, 300);
        }
    }, [analytics, onSignIn]);
    const fetchNotificationsState = () => {
        setUserNotifications({ notifications: [], isLoading: true });
        client.getNotifications().then(retrievedNotifications => {
            setUserNotifications({
                isLoading: false,
                notifications: retrievedNotifications
            });
        });
    };
    const handleNotificationsOpen = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentOpenState = notificationsState.isOpen;
        setNotificationsState(prevState => {
            return Object.assign(Object.assign({}, prevState), { isOpen: !prevState.isOpen });
        });
        if (!currentOpenState) {
            const unreadNotifications = notifications
                .filter(notification => !notification.read)
                .map(({ id }) => id);
            if (unreadNotifications.length) {
                yield client.markNotificationsAsRead(unreadNotifications);
            }
        }
        else {
            // update state when closes the modal
            const markNotificationAsReadInState = notifications.map(notification => {
                if (notification.read)
                    return notification;
                return Object.assign(Object.assign({}, notification), { read: true });
            });
            setUserNotifications({
                isLoading,
                notifications: markNotificationAsReadInState
            });
        }
    });
    const handleOnBegin = () => {
        (0, notifications_1.setOnboardingDone)();
        setNotificationsState(prevState => (Object.assign(Object.assign({}, prevState), { isOnboarding: false })));
    };
    (0, react_1.useEffect)(() => {
        if (identity && withNotifications) {
            fetchNotificationsState();
            const interval = setInterval(() => {
                fetchNotificationsState();
            }, NOTIFICATIONS_QUERY_INTERVAL);
            return () => {
                clearInterval(interval);
            };
        }
        else {
            return () => { };
        }
    }, [identity]);
    return (react_1.default.createElement(UserInformationContainer_1.UserInformationContainer, Object.assign({ notifications: withNotifications
            ? {
                locale: props.locale,
                isLoading,
                isOnboarding: notificationsState.isOnboarding,
                isOpen: notificationsState.isOpen,
                items: notifications,
                activeTab: notificationsState.activeTab,
                onClick: handleNotificationsOpen,
                onClose: handleNotificationsOpen,
                onBegin: handleOnBegin,
                onChangeTab: (_, tab) => setNotificationsState(prevState => (Object.assign(Object.assign({}, prevState), { activeTab: tab })))
            }
            : undefined, onSignOut: handleSignOut, onSignIn: handleSignIn, onClickBalance: handleClickBalance, onOpen: handleOpen, onMenuItemClick: trackMenuItemClick }, rest, { i18n: translations })));
};
exports.UserInformation = UserInformation;
//# sourceMappingURL=UserInformation.js.map